/** Filter bar for the Money tab: date presets + custom range, business, and what to show. */
import React from 'react';
import { Input } from '@/components/ui/input';

const iso = (d) => d.toISOString().slice(0, 10);
const startOfWeek = (d) => { const x = new Date(d); const day = (x.getDay() + 6) % 7; x.setDate(x.getDate() - day); x.setHours(12, 0, 0, 0); return x; };
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const PRESETS = [
  { key: 'today', label: 'Today', range: () => { const t = new Date(); return [iso(t), iso(t)]; } },
  { key: 'week', label: 'This week', range: () => { const s = startOfWeek(new Date()); return [iso(s), iso(addDays(s, 6))]; } },
  { key: 'lastweek', label: 'Last week', range: () => { const s = addDays(startOfWeek(new Date()), -7); return [iso(s), iso(addDays(s, 6))]; } },
  { key: 'month', label: 'This month', range: () => { const t = new Date(); return [iso(new Date(t.getFullYear(), t.getMonth(), 1, 12)), iso(new Date(t.getFullYear(), t.getMonth() + 1, 0, 12))]; } },
  { key: 'lastmonth', label: 'Last month', range: () => { const t = new Date(); return [iso(new Date(t.getFullYear(), t.getMonth() - 1, 1, 12)), iso(new Date(t.getFullYear(), t.getMonth(), 0, 12))]; } },
  { key: 'year', label: 'This year', range: () => { const t = new Date(); return [iso(new Date(t.getFullYear(), 0, 1, 12)), iso(new Date(t.getFullYear(), 11, 31, 12))]; } },
];
export const BUSINESSES = [['all', 'All'], ['probound', 'ProBound'], ['proepoxy', 'ProEpoxy'], ['prodecor', 'ProDecor'], ['training', 'Training'], ['other', 'Other']];
export const SHOW = [['all', 'Everything'], ['sales', 'Sales & profit'], ['portal', 'Payments in (portal)'], ['xero', 'Payments in (Xero)']];

const Chip = ({ on, onClick, children, testid }) => (
  <button type="button" onClick={onClick} aria-pressed={on} data-testid={testid}
    className={`text-xs font-semibold px-3 py-1.5 rounded-full border whitespace-nowrap transition-colors ${on ? 'bg-[#3b2508] text-white border-[#3b2508]' : 'bg-white text-gray-600 border-gray-200 hover:border-gray-400'}`}>{children}</button>
);

export function MoneyFilters({ f, onChange }) {
  const set = (patch) => onChange({ ...f, ...patch });
  return (
    <div className="bg-white rounded-xl border p-3 space-y-3" data-testid="money-filters">
      <div className="flex flex-wrap items-end gap-2">
        <div className="flex flex-wrap gap-1.5">
          {PRESETS.map((p) => <Chip key={p.key} on={f.preset === p.key} onClick={() => { const [s, e] = p.range(); set({ preset: p.key, start: s, end: e }); }} testid={`money-preset-${p.key}`}>{p.label}</Chip>)}
        </div>
        <div className="flex items-end gap-2 ml-auto">
          <label className="text-[11px] font-semibold text-gray-500">From<Input type="date" value={f.start} onChange={(e) => set({ preset: null, start: e.target.value })} className="h-9 mt-0.5 w-[9.5rem]" data-testid="money-start" /></label>
          <label className="text-[11px] font-semibold text-gray-500">To<Input type="date" value={f.end} onChange={(e) => set({ preset: null, end: e.target.value })} className="h-9 mt-0.5 w-[9.5rem]" data-testid="money-end" /></label>
        </div>
      </div>
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        <div>
          <div className="text-[10px] uppercase tracking-wider font-bold text-gray-400 mb-1">Business</div>
          <div className="flex flex-wrap gap-1.5">{BUSINESSES.map(([k, l]) => <Chip key={k} on={f.business === k} onClick={() => set({ business: k })} testid={`money-business-${k}`}>{l}</Chip>)}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wider font-bold text-gray-400 mb-1">Show</div>
          <div className="flex flex-wrap gap-1.5">{SHOW.map(([k, l]) => <Chip key={k} on={f.show === k} onClick={() => set({ show: k })} testid={`money-show-${k}`}>{l}</Chip>)}</div>
        </div>
      </div>
    </div>
  );
}
